import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from "./messages";
import { Button } from '@arnsbogroup/react-voicearchive'

const Forgot = ({ logo, name, url, onSubmit, loading, result }) =>
{
  const { formatMessage } = useIntl()
  return(
  <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 flex flex-col">
    { result && result.emailSent &&
      <div className="flex rounded-md bg-blue-50 p-4">
        <div className="shrink-0 text-blue-400">
          <Icon icon="info" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-blue-700">
            <FormattedMessage {...messages.youWillReceiveEmail}/>
          </p>
          <p className="mt-3 text-sm md:mt-0 md:ml-6">
            <Link to="/user/sign-in" className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600"><FormattedMessage {...messages.goBack}/><span aria-hidden="true">&larr;</span></Link>
          </p>
        </div>
      </div>
    }
    <div className="flex items-center justify-center grow">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img className="mx-auto h-12 w-auto" src={logo} alt={name} />
          <p className="mt-12 text-center text-sm text-gray-600">
            <FormattedMessage {...messages.enterUserName}/> { name } <FormattedMessage {...messages.account}/>
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={onSubmit}>
          <div className="rounded-sm shadow-sm -space-y-px">
            <div>
              <label htmlFor="identifier" className="sr-only"><FormattedMessage {...messages.userOrEmail}/></label>
              <input id="identifier" name="identifier" type="text" autoComplete="username" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-sm focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm" placeholder={formatMessage(messages.userOrEmail)} />
            </div>
          </div>

          <div>
            <Button
              size='sm'
              disabled={loading} 
              type="submit"
              className="w-full"
              icon={['fa', 'lock']}
            >
              { loading ? formatMessage(messages.recovering) : formatMessage(messages.recoverMyAccount) }
            </Button>
          </div>
        </form>

        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-gray-50 text-gray-500">
                <FormattedMessage {...messages.havingTrouble}/>
              </span>
            </div>
          </div>

          <a href="mailto:mail@voicearchive.com">
            <Button
              variant="outline"
              size="sm"
              className="w-full"
              title={formatMessage(messages.getInTouch)}
              icon={['fa', 'external-link']}
              iconPosition="right"
            >
              <FormattedMessage {...messages.getInTouch}/>
            </Button>
          </a>
        </div>
      </div>
    </div>
  </div>
)}

export default Forgot
